var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge",class:_vm.statusClass,style:(_vm.badgeStyle)},[_c('h3',{style:(_vm.textStyle),domProps:{"innerHTML":_vm._s(_vm.text || _vm.label)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }